import * as React from "react";
import { Button } from "@ui-kitten/components";
import { getAuth } from "firebase/auth";
import { useTranslation } from "react-i18next";
import { useNavigation } from "@react-navigation/native";
import { StyleSheet, View } from "react-native";
import useAuth from "../hooks/useAuth";
import ScreenContainer from "../components/ScreenContainer";

declare global {
    export namespace JSX {
        interface IntrinsicElements {
            "stripe-pricing-table": {
                "pricing-table-id": string;
                "publishable-key": string;
                "client-reference-id"?: string;
            };
        }
    }
}

const PaymentScreen = () => {
    const { user } = useAuth();
    const { t } = useTranslation();
    const navigation = useNavigation();
    return (
        <ScreenContainer>
            <View style={styles.pricingTableContainer}>
                <stripe-pricing-table
                    pricing-table-id="prctbl_1NQSHKCNIU9HtVuZ0dlAZYJH"
                    publishable-key="pk_live_51MohvwCNIU9HtVuZJp1T6j4e6JHb7CDUGGM9BgC9tgeQie74N6ZPGZCIhUjdsFTJNZ4vw967yRmBp3kSP62B66K600nevLkprI"
                    customer-email={user?.email}
                />
            </View>
            <View style={styles.container}>
                <View style={styles.inputMargin}>
                    <Button
                        appearance="outline"
                        status="info"
                        onPress={() => navigation.goBack()}
                    >
                        {t("labels.goBack")}
                    </Button>
                </View>
                <View style={styles.inputMargin}>
                    <Button
                        appearance="outline"
                        status="info"
                        onPress={async () => {
                            await getAuth().signOut();
                        }}
                    >
                        {t("labels.logout")}
                    </Button>
                </View>
            </View>
        </ScreenContainer>
    );
};

const styles = StyleSheet.create({
    pricingTableContainer: {
        marginTop: 30,
    },
    container: {
        marginTop: 30,
        flex: 1,
        alignItems: "center",
    },
    inputMargin: {
        minWidth: 317,
        marginTop: 15,
    },
});

export default PaymentScreen;
